// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1e0oW","info":"UpdateTermsInfo_info__pBRTG"};